import { BanknoteArrowUpIcon, MailIcon, PickaxeIcon, ShirtIcon } from 'lucide-react';

import type { RouteListItem, ToPath } from '@/types';

import BankIcon from '../images/icons/bank.svg?react';
import CompaniesIcon from '../images/icons/clientsSettings.svg?react';
import FinanceIcon from '../images/icons/finance.svg?react';
import GeneralIcon from '../images/icons/general.svg?react';
import ProductsIcon from '../images/icons/products-services.svg?react';
import SecurityIcon from '../images/icons/security.svg?react';
import TeamIcon from '../images/icons/team.svg?react';

const general: RouteListItem[] = [
  { path: '/settings/brands', name: 'Brands', auditKey: 'brand' },
  { path: '/settings/partners', name: 'Partners', auditKey: 'partner' },
  { path: '/settings/registrars', name: 'Registrar', auditKey: 'registrar' },
  { path: '/settings/infrastructures', name: 'Infrastructures', auditKey: 'infrastructure' },
  { path: '/settings/business-disciplines', name: 'Business Disciplines', auditKey: 'business-discipline' },
  { path: '/settings/billing-terms', name: 'Billing Terms', auditKey: 'billing-term' },
  { path: '/settings/system-files', name: 'System Files', auditKey: 'system-file' },
  { path: '/settings/countries', name: 'Countries', auditKey: 'country' },
  { path: '/settings/view-logs', name: 'View Logs', auditKey: 'view-log' },
  {
    path: '/settings/revenue-allocation-lockdown-override-logs',
    name: 'Revenue Allocation Lockdown Override Logs',
    auditKey: 'revenue-allocation-lockdown-override-logs',
  },
];

// const mileage: RouteListItem[] = [{ path: '/settings/mileage-rates', name: 'Mileage Rates', auditKey: 'mileage-rate' }];

const teamMembers: RouteListItem[] = [
  { path: '/settings/job-positions', name: 'Job Positions', auditKey: 'job-position' },
  { path: '/settings/departments', name: 'Departments', auditKey: 'department' },
  { path: '/settings/salary-grades', name: 'Salary Grades', auditKey: 'salary-grade' },
  { path: '/settings/preferred-relationships', name: 'Preferred Relationships', auditKey: 'preferred-relationship' },
  { path: '/settings/preferred-locations', name: 'Preferred Locations', auditKey: 'preferred-location' },
];

const companies: RouteListItem[] = [
  { path: '/settings/billing-systems', name: 'Billing Systems', auditKey: 'billing-system' },
  { path: '/settings/magazines', name: 'Magazines', auditKey: 'magazine' },
  { path: '/settings/audiences', name: 'Audiences', auditKey: 'audience' },
  { path: '/settings/organization-types', name: 'Organization Types', auditKey: 'organization-type' },
  { path: '/settings/industries', name: 'Industries', auditKey: 'industry' },
  { path: '/settings/relationship-scores', name: 'Relationship Scores', auditKey: 'relationship-score' },
];

// const contacts: RouteListItem[] = [{ path: '/settings/partners', name: 'Partners', auditKey: 'partner' }];

// const playbook: RouteListItem[] = [{ path: '/settings/partners', name: 'Partners', auditKey: 'partner' }];

// const culture: RouteListItem[] = [{ path: '/settings/partners', name: 'Partners', auditKey: 'partner' }];

const productAS: RouteListItem[] = [
  { path: '/settings/categories', name: 'Categories', auditKey: 'category' },
  { path: '/settings/unit-sell-bys', name: 'Unit Sell Bys', auditKey: 'unit-sell-by' },
  { path: '/settings/price-frequencies', name: 'Price Frequencies', auditKey: 'price-frequency' },
  { path: '/settings/manufacturers', name: 'Manufacturers', auditKey: 'manufacturer' },
  {
    path: '/settings/products-and-services-templates',
    name: 'Product & Service Template',
    auditKey: 'products-and-services-templates',
  },
];

const security: RouteListItem[] = [{ path: '/settings/user-roles', name: 'User Roles', auditKey: 'role' }];

const termsAndConditions: RouteListItem[] = [
  { path: '/settings/terms-categories', name: 'Terms Categories', auditKey: 'terms-condition-category' },
  { path: '/settings/terms-conditions', name: 'Terms Conditions', auditKey: 'terms-condition' },
  { path: '/settings/terms-templates', name: 'Terms Templates', auditKey: 'terms-condition-template' },
];

const inventory: RouteListItem[] = [
  { path: '/settings/inventory-categories', name: 'Inventory Categories', auditKey: 'inventory-category' },
  { path: '/settings/inventory-vendors', name: 'Vendors', auditKey: 'vendor' },
  { path: '/settings/inventory-bin-locations', name: 'Bin Locations', auditKey: 'bin-location' },
  { path: '/settings/inventory-volumes', name: 'Inventory Volumes', auditKey: 'inventory-volume' },
  { path: '/settings/inventory-kits', name: 'Inventory Kits', auditKey: 'inventory-kit' },
];

const recruiting: RouteListItem[] = [
  { path: '/settings/recruiting-statuses', name: 'Recruiting Statuses', auditKey: 'recruiting-status' },
  { path: '/settings/recruiting-job-categories', name: 'Job Categories', auditKey: 'recruiting-job-category' },
  {
    path: '/settings/recruiting-hiring-criteria-categories',
    name: 'Hiring Criteria Categories',
    auditKey: 'hiring-criteria-category',
  },
];

const sales: RouteListItem[] = [
  { path: '/settings/commission-plans', name: 'Commission Plans', auditKey: 'commission-plan' },
  { path: '/settings/revenue-lockdowns', name: 'Revenue Lockdowns', auditKey: 'revenue-lockdown' },
];

const emails: RouteListItem[] = [
  { path: '/settings/email-templates', name: 'Email Templates', auditKey: 'email-templates' },
  { path: '/settings/email-template-defaults', name: 'Email Template Defaults', auditKey: 'email-template-default' },
  { path: '/settings/email-history', name: 'Email History', auditKey: 'email-history' },
];

const accounting: RouteListItem[] = [
  { path: '/settings/payment-methods', name: 'Payment Methods', auditKey: 'payment-method' },
];

const finance: RouteListItem[] = [{ path: '/settings/bank-accounts', name: 'Bank Accounts', auditKey: 'bank-account' }];

export const SETTINGS_ROUTES_LIST = [
  {
    name: 'General',
    icon: GeneralIcon,
    list: general,
  },
  {
    name: 'Team Members',
    icon: TeamIcon,
    list: teamMembers,
  },
  {
    name: 'Companies',
    icon: CompaniesIcon,
    list: companies,
  },
  {
    name: 'Products & Services',
    icon: ProductsIcon,
    list: productAS,
  },
  {
    name: 'Security',
    icon: SecurityIcon,
    list: security,
  },
  {
    name: 'Agreements',
    icon: TeamIcon,
    list: termsAndConditions,
  },
  {
    name: 'Inventory',
    icon: ShirtIcon,
    list: inventory,
  },
  {
    name: 'Recruiting',
    icon: PickaxeIcon,
    list: recruiting,
  },
  {
    name: 'Sales',
    icon: BanknoteArrowUpIcon,
    list: sales,
  },
  {
    name: 'Accounting',
    icon: BankIcon,
    list: accounting,
  },
  {
    name: 'Finance',
    icon: FinanceIcon,
    list: finance,
  },
  // {
  //   name: 'Mileage Tracking',
  //   icon: CarIcon,
  //   list: mileage,
  // },
  {
    name: 'Emails',
    icon: MailIcon,
    list: emails,
  },
];

export type TItems = (typeof SETTINGS_ROUTES_LIST)[number];

export const createSettingsNested = (): RouteListItem[] => {
  return SETTINGS_ROUTES_LIST.flatMap((section) =>
    section.list.map((item) => ({
      path: `${item.path}/$id` as ToPath,
      name: item.name,
      auditKey: item.auditKey,
    }))
  );
};

export const settingsSubNav: RouteListItem[] = createSettingsNested();
